"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const string_1 = require("../../../common/js/helper/string");
const media_1 = require("../../helper/media");
const softwareColumns_1 = require("../../helper/softwareColumns");
const LicenseStore_1 = __importDefault(require("../../stores/LicenseStore"));
const TableSub_1 = __importDefault(require("../TableSub"));
const ExpandedLicenseItemButtons_1 = require("./ExpandedLicenseItemButtons");
class AssetsSoftwareTableExpandedItem extends react_1.default.Component {
    rowElementRef = react_1.default.createRef();
    componentDidMount() {
        if (this.props.data?.id === this.props.match.params.softwareId && !!this.rowElementRef.current) {
            this.rowElementRef.current.parentElement?.previousElementSibling?.scrollIntoView(true);
        }
    }
    render() {
        const { data } = this.props;
        const type = (0, string_1.slugifyKey)(data?.productType);
        const subtableLicenses = LicenseStore_1.default.getSubLicenses(data);
        const detailColumns = (0, softwareColumns_1.getSoftwareDetailColumns)(type, data?.lockType);
        const infoText = this.props.t('myassets.software.table.license_refresh_notice', { type });
        // To trigger the observable values.
        LicenseStore_1.default.deactivateEllipsis.length;
        return (react_1.default.createElement("div", { className: "znd-assets-table-sub", ref: this.rowElementRef },
            react_1.default.createElement("div", { className: "d-flex flex-row" },
                data?.media ? (react_1.default.createElement("img", { className: "znd-assets-table-sub__image", ...(0, media_1.imageSourceFromMedia)(data.media) })) : null,
                subtableLicenses ? (react_1.default.createElement(TableSub_1.default, { columns: detailColumns, data: subtableLicenses, className: "znd-assets-table-sub__table" })) : null),
            !!infoText && !!subtableLicenses ? react_1.default.createElement("div", { className: "znd-assets-table-sub__info" }, infoText) : null,
            react_1.default.createElement(ExpandedLicenseItemButtons_1.ExpandedLicenseItemButtons, { license: data })));
    }
}
exports.default = (0, react_i18next_1.withTranslation)()((0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(AssetsSoftwareTableExpandedItem)));
